module.exports = __webpack_public_path__ + "static/img/Daniel-Tupou.cdefa4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Tupou.jpg
// module id = hyPy
// module chunks = 0